<h2 class="bd-title">General Settings</h2>
@if (errorMessage) {
  <alert type="danger" [dismissible]="true" (onClose)="errorMessage = undefined">
    <coso-alert-message>
      <div class="d-inline" [innerHTML]="errorMessage"></div>
    </coso-alert-message>
  </alert>
}

<form #settingsForm="ngForm" id="settingsForm">
  @if (settings$ | async; as settings) {
    <div class="cs-row">
      <div class="cs-label-wrapper">
        <label id="groupStorageLabel" for="groupStorage" class="cs-larger-text cs-bolder-text">Group Storage</label>
        <div id="groupStorageSubLabel" class="cs-secondary-text">
          Select the target system for creating and maintaining groups and memberships. Be aware that in order to use Microsoft Entra ID
          @if (!isSaaS) {
            <span> or Active Directory</span>
          }, you will need to have only one SharePoint connection configured.
        </div>
      </div>
      <div class="cs-input-wrapper">
        <select
          class="form-control"
          id="groupStorage"
          name="groupStorage"
          aria-describedby="groupStorageSubLabel"
          [(ngModel)]="settings.groupStorage"
          (ngModelChange)="updateSettings(settings)"
          [disabled]="readonly$ | async"
        >
          <option [ngValue]="GroupStorage.SharePoint">SharePoint</option>
          <option [ngValue]="GroupStorage.AzureActiveDirectory" [disabled]="settings.sharePoint.sharepointConfig.length > 1">Microsoft Entra ID</option>
          @if (!isSaaS) {
            <option [ngValue]="GroupStorage.ActiveDirectory" [disabled]="settings.sharePoint.sharepointConfig.length > 1">Active Directory</option>
          }
        </select>
      </div>
    </div>
    
    @if (!isSaaS) {
      <div class="cs-row">
        <div class="cs-label-wrapper">
          <label id="poolNotificationIntervalLabel" for="poolNotificationInterval" class="cs-larger-text cs-bolder-text">Polling time</label>
          <div id="poolNotificationIntervalSubLabel" class="cs-secondary-text">Set the interval of time (in seconds) between checks for new events from Dynamics 365</div>
        </div>
        <div class="cs-input-wrapper">
          <input
            type="number"
            class="form-control"
            id="poolNotificationInterval"
            name="poolNotificationInterval"
            #poolNotificationInterval="ngModel"
            min="1"
            max="99"
            [class.is-invalid]="poolNotificationInterval.touched && poolNotificationInterval.invalid"
            cosoRangeValidator
            [attr.aria-invalid]="poolNotificationInterval.invalid"
            [attr.aria-describedby]="'poolNotificationIntervalSubLabel' + (poolNotificationInterval.touched && poolNotificationInterval.invalid ? ' poolNotificationInterval-errors' : '')"
            [(ngModel)]="settings.poolNotificationInterval"
            (ngModelChange)="updateSettings(settings)"
            [disabled]="readonly$ | async"
          />
          <span class="fa fa-times invalid-feedback-icon" aria-hidden="true"></span>
          @if (poolNotificationInterval.touched && poolNotificationInterval.invalid) {
            @if (poolNotificationInterval.errors?.min) {
              <div class="invalid-feedback" id="poolNotificationInterval-errors" role="alert">
                The Polling time field must be greater than or equal to 1.
              </div>
            }
            @if (poolNotificationInterval.errors?.max) {
              <div class="invalid-feedback" id="poolNotificationInterval-errors" role="alert">The Polling time field must be less than or equal to 99.</div>
            }
          }
        </div>
      </div>
    }
    <div class="cs-row">
      <div class="cs-label-wrapper">
        <label id="autoStartLabel" for="autoStart" class="cs-larger-text cs-bolder-text">Auto start</label>
        <div id="autoStartSubLabel" class="cs-secondary-text">
          @if(!isSaaS) {
            Select the start mode of the replication process (including after a reboot).
          }
          @else {
            Select the start mode of the replication process after subscription expiry and renewal.
          }
          <ul>
            <li>Disabled: Indicates that the replication process is started only manually.</li>
            @if (!isSaaS){
              <li>Enabled: Indicates that the replication process is started automatically. A previous status is ignored.</li>
            }
            <li>Automatic: Indicates that the replication process is started automatically based on the previous status.</li>
          </ul>
        </div>
      </div>
      <div class="cs-input-wrapper">
        <select
          class="form-control"
          id="autoStart"
          name="autoStart"
          aria-describedby="autoStartSubLabel"
          [(ngModel)]="settings.autoStart"
          (ngModelChange)="updateSettings(settings)"
          [disabled]="readonly$ | async"
        >
          @for (mode of modes; track mode) {
            <option [ngValue]="AutoStartMode[mode]">{{ getAutoStartModeName(mode) }}</option>
          }
        </select>
      </div>
    </div>
   
    <div class="cs-row">
      <div class="cs-label-wrapper">
        <div id="autoEventBulkDeleteLabel" class="cs-larger-text cs-bolder-text">Automatically delete unnecessary events from Dynamics 365</div>
        <div id="autoEventBulkDeleteSubLabel" class="cs-secondary-text">Events that are no longer needed will be deleted via bulk delete job</div>
      </div>
      <div class="custom-control custom-switch">
        <input
          role="switch"
          type="checkbox"
          class="custom-control-input"
          id="autoEventBulkDelete"
          name="autoEventBulkDelete"
          aria-labelledby="autoEventBulkDeleteLabel"
          aria-describedby="autoEventBulkDeleteSubLabel"
          [attr.aria-checked]="settings.autoEventBulkDelete"
          [(ngModel)]="settings.autoEventBulkDelete"
          (ngModelChange)="updateSettings(settings)"
          [disabled]="readonly$ | async"
        />
        <label class="custom-control-label" for="autoEventBulkDelete">{{ settings.autoEventBulkDelete ? 'On' : 'Off' }}</label>
      </div>
    </div>

    @if (isSaaS === false) {
      <coso-dynamic-view-loader componentName="general-settings" [data]="settings" (action)="propagate($event)"></coso-dynamic-view-loader>
    }
  }
</form>
